<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M11.143 4.714H7.286V.857A.857.857 0 0 0 6.429 0H5.57a.857.857 0 0 0-.857.857v3.857H.857A.857.857 0 0 0 0 5.571v.858c0 .473.384.857.857.857h3.857v3.857c0 .473.384.857.857.857h.858a.857.857 0 0 0 .857-.857V7.286h3.857A.857.857 0 0 0 12 6.429V5.57a.857.857 0 0 0-.857-.857z" id="skic80v46a"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="8rld5kjhtb" fill="#fff">
            <use xlink:href="#skic80v46a"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#skic80v46a"/>
        <g mask="url(#8rld5kjhtb)" fill="currentColor">
            <path d="M-2.4-3h18v18h-18z"/>
        </g>
    </g>
</svg>
